/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import moment from 'moment/moment'
import { useNavigate, useSearchParams } from 'react-router-dom-v5-compat'
import AdvancedFilters from '../Home/AdvancedFilters'
import { Form } from 'semantic-ui-react'
import { UltyDropdown } from '@ulty/ulty-ui'
import { useTranslation } from 'react-i18next'
import { periodToDate } from './period.service'

const defaultFrom = moment().startOf('day').local()
const defaultTo = moment().endOf('day').local()

const Filters = () => {
    const [t] = useTranslation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    const from = searchParams.get('from')
    const to = searchParams.get('to')
    const scale = searchParams.get('scale') ?? 'week'
    const period = searchParams.get('period') ?? '0'
    const platformIds = searchParams.getAll('platform')
    const maxPeriod = 2

    if (!from || !to) {
        const params = new URLSearchParams(searchParams)
        if (!from) params.set('from', defaultFrom.toISOString())
        if (!to) params.set('to', defaultTo.toISOString())
        setSearchParams(params)
    }


    const scales = [{
        key: 'week',
        value: 'week',
        text: t('catchment_area.filters.scale.week'),
    }, {
        key: 'month',
        value: 'month',
        text: t('catchment_area.filters.scale.month'),
    }]

    const periodLabel = +period === 0 ? 'en cours' : `${period}`

    return (
      <>
          <AdvancedFilters
            filters={{
                dateRange: {
                    minDate: moment().subtract(3, 'month'),
                    maxDate: moment(),
                    startDate: moment(from || defaultFrom),
                    endDate: moment(to || defaultTo),
                },
                platformIds,
            }}
            onFiltersChange={(filters) => {
                const params = new URLSearchParams(searchParams)
                if (filters.dateRange.startDate) {
                    params.set('from', filters.dateRange.startDate.startOf('day').toISOString())
                }
                if (filters.dateRange.endDate) {
                    params.set('to', filters.dateRange.endDate.endOf('day').toISOString())
                }
                params.delete('platform')
                filters.platformIds?.forEach(id => params.append('platform', id))

                navigate({search: params.toString()})
            }}
          >
              <AdvancedFilters.DateRangeFilter/>
              <Form css={css` display: flex;`}>
                  <AdvancedFilters.PlatformFilter/>
              </Form>
          </AdvancedFilters>

          <UltyDropdown
            label={undefined}
            loading={false}
            multiple={false}
            options={scales}
            value={scale}
            onChange={(_e, dp) => {
                const {from, to} = periodToDate({scale: dp.value, period})
                setSearchParams(new URLSearchParams({
                    ...Object.fromEntries(searchParams.entries()),
                    scale: dp.value,
                    ...(from && {from}),
                    ...(to && {to}),
                }))
            }}
          />

          <input
            type="range"
            min={0}
            max={maxPeriod}
            value={+period + maxPeriod}
            onChange={(e) => {
                const newPeriod = e.target.value - maxPeriod
                const {from, to} = periodToDate({scale, period: newPeriod})
                setSearchParams(new URLSearchParams({
                    ...Object.fromEntries(searchParams.entries()),
                    period: newPeriod,
                    ...(from && {from}),
                    ...(to && {to}),
                }))
            }}
          />

          <p>Periode: {t(`catchment_area.filters.scale.${scale}`)} {periodLabel}</p>
      </>
    )
}

export { Filters }
